export const CONVERSION_WHITELIST = new Set([
  'sign_up_success',
  'purchase',
  'first_deposit',
  'submit_deposit',
  'bank_verification_success',
  'login_success',
  'pwa_open',
  'pwa_first_open',
])

export const DEV_ONLY_CONVERSION_EVENTS = new Set(['activity_click'])

export const HIGH_FREQ_DENYLIST = new Set(['page_view', 'open_page', 'close_page', 'lobby_click', 'game_click', 'click', 'error_event', 'search'])

export const SECOND_ARG_EVENTS = new Set(['purchase', 'first_deposit', 'sign_up_success'])

export const shouldSendConversion = ({ event, isDevLike, gateTraceId }) => {
  const isWhitelisted = CONVERSION_WHITELIST.has(event) || (isDevLike && DEV_ONLY_CONVERSION_EVENTS.has(event))
  return isWhitelisted && !!gateTraceId
}

export const resolveConversionDispatch = ({ event, isDevLike, secondArg, opts, cookieTraceId }) => {
  const attribution = opts?.conversionAttribution
  const gateTraceId = attribution ? attribution.traceId : cookieTraceId
  if (!shouldSendConversion({ event, isDevLike, gateTraceId })) return null

  return {
    eventId: SECOND_ARG_EVENTS.has(event) ? secondArg?.eventID : undefined,
    attribution: attribution || undefined,
  }
}
